import { getMunicipalityName, getProvinceByCode } from 'utils/location';
import { IOfferPlace } from '../interfaces';

/**
 * Codigo -> nombre para pintar un lugar del alcance. `city` nulo significa toda
 * la provincia, y se dice explicitamente: sin el sufijo, "La Habana" a secas se
 * confunde con el municipio homonimo que no existe pero que el operador supone.
 *
 * `allLabel` se pasa ya traducido porque esto no es un componente.
 *
 * OJO con la fuente de los nombres: `places` habla el idioma de ms-location
 * (La Habana = '39', Boyeros = '1026'), el mismo de `x-shop-state` /
 * `x-shop-city`. `utils/location` resuelve esos codigos contra
 * `modules/common/constants/state-codes`, que es el catalogo de ms-location del
 * repo. NO usar `findProvinceByStateCode` / `findMunicipalityByStateAndMunicipality`
 * de `@dfl/location`: ese paquete usa otro sistema (La Habana = '23') y con un
 * codigo de ms-location devuelve `undefined`, dejando el chip con el codigo crudo.
 */
export const getOfferPlaceLabel = (place: IOfferPlace, allLabel: string): string => {
  const provinceName = getProvinceByCode(Number(place?.state)) || place?.state || '';

  if (!place?.city) return `${provinceName} — ${allLabel}`;

  const municipalityName = getMunicipalityName(Number(place?.state), Number(place?.city)) || place?.city;
  return `${municipalityName}, ${provinceName}`;
};
